<template>
  <div class="my-3" v-if="taskData">
    <b-row class="mb-2" v-if="taskData.typeOfChangeBeingFiled === 'MULTI_CHANGES'">
      <b-col>
        <b-badge class="bg-green mx-1">Incoming Filings <i class="fa fa-arrow-right text-white"></i></b-badge>
        <b-badge class="bg-blue mx-1"
                 v-for="(file,idx) in taskData.embeddedChangesBeingFiled" :key="idx">
          {{ filingName(file.typeOfChangeBeingFiled) }}
        </b-badge>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
          <thead>
          <tr class="bg-gray-pale">
            <td colspan="12" class="px-2 py-2 font-bold">Resolution Details</td>
          </tr>
          </thead>
          <tbody>
          <tr style="border: solid 1px #dedede;">
            <td class="px-2 py-1 text-capitalize font-bold">Registration Number</td>
            <td class="px-2 py-1 text-capitalize">{{ taskData.brn }}</td>
          </tr>
          <tr style="border: solid 1px #dedede;">
            <td class="px-2 py-1 text-capitalize font-bold">Organ of Company</td>
            <td class="px-2 py-1 text-capitalize">{{ cleanName(taskData.organ) }}</td>
          </tr>
          <tr style="border: solid 1px #dedede;">
            <td class="px-2 py-1 text-capitalize font-bold">Resolution Name</td>
            <td class="px-2 py-1 text-capitalize">
              {{ cleanName(taskData.resolutionName) }}
            </td>
          </tr>
          <tr style="border: solid 1px #dedede;">
            <td class="px-2 py-1 text-capitalize font-bold">Subject</td>
            <td class="px-2 py-1 text-capitalize">{{ taskData.subject }}</td>
          </tr>
          <tr style="border: solid 1px #dedede;">
            <td class="px-2 py-1 text-capitalize font-bold">Date of Meeting</td>
            <td class="px-2 py-1 text-capitalize">
              {{ dateFormat(taskData.dateOfMeeting) }}
            </td>
          </tr>
          <tr style="border: solid 1px #dedede;">
            <td class="px-2 py-1 text-capitalize font-bold">Venue of Meeting</td>
            <td class="px-2 py-1 text-capitalize">
              <span v-if="taskData.venue">{{ taskData.venue }}</span>
              <span v-else>N/A</span>
            </td>
          </tr>
          <tr style="border: solid 1px #dedede;">
            <td class="px-2 py-1 text-capitalize font-bold">Filing Date</td>
            <td class="px-2 py-1 text-capitalize">
              {{ dateFormat(taskData.filingDate) }}
            </td>
          </tr>
          <tr style="border: solid 1px #dedede;">
            <td class="px-2 py-1 text-capitalize font-bold">Presented by</td>
            <td class="px-2 py-1 text-capitalize">{{ taskData.presenter ? taskData.presenter.givenName : '' }}
            </td>
          </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <NameChange v-if="taskData.typeOfChangeBeingFiled === 'CHANGE_OF_NAME'"
                    :data="taskData"
                    :attachments="taskData.attachments"/>

        <Dormancy v-if="taskData.typeOfChangeBeingFiled === 'DORMANCY'"
                  :form="taskData.form"
                  :attachments="taskData.attachments"/>

        <MultiChanges v-if="taskData.typeOfChangeBeingFiled === 'MULTI_CHANGES'"
                      :data="taskData"
                      :task-id="continuousFilingTask.taskId"
                      :brn="taskData.brn"/>

        <CompanyReregistration v-if="taskData.typeOfChangeBeingFiled === 'RE_REGISTRATION'"
                               :type="taskData.resolutionType"
                               :data="taskData.embeddedChanges"/>

        <CompanyConversion v-if="taskData.typeOfChangeBeingFiled === 'CONVERSION'"
                           :type="taskData.resolutionType"
                           :data="taskData.embeddedChanges"/>


        <CompanyAmalgamation v-if="taskData.typeOfChangeBeingFiled === 'AMALGAMATION'"
                             :type="taskData.resolutionType"
                             :application="continuousFilingTask"
                             :draftData="taskData.embeddedChanges"/>

        <file-form-a23 v-if="taskData.resolutionType === 'FILE_FORM_A23'"
                       :data="taskData.form"/>
        <FileForm17 v-if="taskData.resolutionType === 'FILE_FORM_17'"
                    :data="taskData.form"/>
        <FileForm18 v-if="taskData.resolutionType === 'FILE_FORM_18'"
                    :data="taskData.form"/>
        <ContinousFilingBeneficialOwners
            v-if="taskData.resolutionType === 'BENEFICIAL_OWNER_SHIP_FORM_METADATA'"
            :data="taskData.form"></ContinousFilingBeneficialOwners>
        <ContinuousChangeBeneficialOwners
            v-if="taskData.resolutionType === 'NOTICE_OF_CHANGE_OF_BENEFICIAL_OWNER'"
            :data="taskData"
        ></ContinuousChangeBeneficialOwners>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment";
import NameChange from "@/views/home/services/continuous-filing/task/components/NameChange";
import Dormancy from "@/views/home/services/continuous-filing/task/components/Dormancy";
import MultiChanges from "@/views/home/services/continuous-filing/task/components/MultiChanges";
import FileForm18 from "@/views/home/services/continuous-filing/task/components/FileForm18";
import FileForm17 from "@/views/home/services/continuous-filing/task/components/FileForm17.vue";
import FileFormA23 from "@/views/home/services/continuous-filing/task/components/FileFormA23.vue";
import CompanyReregistration from "@/views/home/services/continuous-filing/task/components/CompanyReregistration.vue";
import CompanyConversion from "@/views/home/services/continuous-filing/task/components/CompanyConversion.vue";
import CompanyAmalgamation from "@/views/home/services/continuous-filing/task/components/CompanyAmalgamation.vue";
import ContinousFilingBeneficialOwners
  from "@/views/home/services/continuous-filing/task/ContinousFilingBeneficialOwners.vue";
import ContinuousChangeBeneficialOwners
  from "@/views/home/services/continuous-filing/task/ContinuousChangeBeneficialOwners.vue";

export default {
  name: "ContinuousFilingFormDetails",
  components: {
    ContinuousChangeBeneficialOwners,
    ContinousFilingBeneficialOwners,
    CompanyAmalgamation,
    CompanyConversion,
    CompanyReregistration,
    FileFormA23,
    FileForm17,
    FileForm18,
    MultiChanges,
    Dormancy,
    NameChange
  },
  data() {
    return {
      attachmentUrl: null,
      individualDirectors: [],
      corporateDirectors: [],
      individualSecretary: null,
      corporateSecretary: null,
      adoptionTableText: null
    }
  },
  mounted() {

  },
  methods: {
    dateFormat(date) {
      return moment(date).format("DD-MM-YYYY")
    },
    cleanName(name) {
      if (name) {
        let n = name.replaceAll("_", " ")
        return n.toLowerCase()
      } else {
        return "N/A"
      }
    },

  },
  computed: {
    ...mapGetters(["getContinuousFilingTask"]),
    continuousFilingTask() {
      return this.getContinuousFilingTask || {};
    },
    taskData() {
      return this.continuousFilingTask.data || null;
    }
  },
  watch: {
    taskData: {
      immediate: true,
      handler(val) {
        console.log("ContinuousFilingFormDetails taskData:", val);
        console.log("ContinuousFilingFormDetails taskData.form:", val ? val.form : null);
      }
    }
  }
}
</script>

<style scoped>
th, td {
  font-size: 12px;
}
</style>